import { useState } from 'react';
import Team from '../../components/Team.jsx';
import '../../css/PremierLeagueTeams.css';

const teamsData = [
    { img: "https://sco.wikipedia.org/wiki/Special:Redirect/file/Arsenal_FC.svg", name: "Arsenal" },
    { img: "https://fr.wikipedia.org/wiki/Special:Redirect/file/Logo_Aston_Villa.svg", name: "Aston Villa" },
    { img: "https://sco.wikipedia.org/wiki/Special:Redirect/file/AFC_Bournemouth_(2013).svg", name: "Bournemouth" },
    { img: "https://fr.wikipedia.org/wiki/Special:Redirect/file/Brentford_FC_logo.svg", name: "Brentford" },
    { img: "https://sco.wikipedia.org/wiki/Special:Redirect/file/Brighton_%26_Hove_Albion_logo.svg", name: "Brighton Hove Albion" },
    { img: "https://en.wikipedia.org/wiki/Special:Redirect/file/Burnley_FC_Logo.svg", name: "Burnley" },
    { img: "https://sco.wikipedia.org/wiki/Special:Redirect/file/Chelsea_FC.svg", name: "Chelsea" },
    { img: "https://sco.wikipedia.org/wiki/Special:Redirect/file/Crystal_Palace_FC_logo.svg", name: "Crystal Palace" },
    { img: "https://sco.wikipedia.org/wiki/Special:Redirect/file/Everton_FC_logo.svg", name: "Everton" },
    { img: "https://en.wikipedia.org/wiki/Special:Redirect/file/Fulham_FC_(shield).svg", name: "Fulham" },
    { img: "https://fr.wikipedia.org/wiki/Special:Redirect/file/Logo_Leeds_United_FC.svg", name: "Leeds United" },
    { img: "https://sco.wikipedia.org/wiki/Special:Redirect/file/Liverpool_FC.svg", name: "Liverpool" },
    { img: "https://sco.wikipedia.org/wiki/Special:Redirect/file/Manchester_City_FC_badge.svg", name: "Manchester City" },
    { img: "https://sco.wikipedia.org/wiki/Special:Redirect/file/Manchester_United_FC_crest.svg", name: "Manchester United" },
    { img: "https://sco.wikipedia.org/wiki/Special:Redirect/file/Newcastle_United_Logo.svg", name: "Newcastle United" },
    { img: "https://sco.wikipedia.org/wiki/Special:Redirect/file/Nottingham_Forest_logo.svg", name: "Nottingham Forest" },
    { img: "https://sco.wikipedia.org/wiki/Special:Redirect/file/Logo_Sunderland.svg", name: "Sunderland" },
    { img: "https://sco.wikipedia.org/wiki/Special:Redirect/file/Tottenham_Hotspur.svg", name: "Tottenham Hotspur" },
    { img: "https://sco.wikipedia.org/wiki/Special:Redirect/file/West_Ham_United_FC_logo.svg", name: "West Ham United" },
    { img: "https://sco.wikipedia.org/wiki/Special:Redirect/file/Wolverhampton_Wanderers.svg", name: "Wolverhampton Wanderers" },
];

const PremierLeagueTeams = () => {
    const [searchTerm, setSearchTerm] = useState("");

    const filteredTeams = teamsData.filter(team =>
        team.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <main id="premier-league-teams-content">
            <h2 id="quest">Premier League Teams</h2>
            <input
                type="text"
                placeholder="Search teams..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                style={{
                    margin: '1rem 0',
                    marginLeft: '10px',
                    padding: '0.5rem',
                    fontSize: '1rem',
                    width: '250px',
                    background: '#fff',
                    color: '#111'
                }}
            />
            <section id="premier-league-teams-section">
                {filteredTeams.map(team => (
                    <Team key={team.name} img={team.img} name={team.name} />
                ))}
            </section>
        </main>
    );
};

export default PremierLeagueTeams;